import { useEffect, useState } from "react";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { ChatCenteredText } from "@phosphor-icons/react";

/** "Quick reply" picker for the inbox reply box — lists the company snippets with placeholders already filled in for
 *  this email; picking one sets / appends the reply text (and the subject when the snippet has one). */
export default function QuickReplyPicker({ messageId, onPick }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!open || items) return;
    API.get(`/inbox/messages/${messageId}/snippets`).then((r) => setItems(r.data.snippets)).catch(() => setItems([]));
  }, [open, items, messageId]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" data-testid="inbox-quick-reply-btn"><ChatCenteredText size={13} className="mr-1" /> Quick reply</Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[400px] p-0" data-testid="inbox-quick-reply-popover">
        <div className="max-h-[360px] overflow-y-auto p-1.5">
          {items === null && <p className="p-3 text-xs text-muted-foreground">Loading snippets…</p>}
          {items && items.length === 0 && <p className="p-3 text-xs text-muted-foreground" data-testid="inbox-quick-reply-empty">No snippets yet — an admin can add them under Mailbox settings → Quick-reply snippets.</p>}
          {(items || []).map((s) => (
            <button key={s.id} type="button" onClick={() => { onPick(s); setOpen(false); }} className="w-full text-left rounded-md px-2.5 py-2 hover:bg-muted/50 transition-colors" data-testid={`inbox-quick-reply-${s.id}`}>
              <p className="text-xs font-semibold">{s.title}</p>
              <p className="text-[11px] text-muted-foreground line-clamp-2">{s.text.replace(/\s*\n+\s*/g, " ")}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
